import React, { useState } from 'react';
import {
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBInput,
  MDBBox,
  MDBBtn,
} from 'mdbreact';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Loading from '../ui-components/loading';

import addNotification from 'helpers/notify';
import { choseToggle } from 'helpers/toggleIfLoading';
import { useHttp } from 'hooks/useHttp';
import { editPost } from 'api/brands/editPost';
import { companyAdminEditPost } from 'actions/company-admin';

const EditPostModal = props => {
  const [postItemState, setPostItemState] = useState(
    props.postItem,
  );
  const [json, setJson] = useState(null);
  const [xlsx, setXlsx] = useState(null);
  const [obj, setObj] = useState(null);
  const [mtl, setMtl] = useState(null);
  const [pdf, setPdf] = useState(null);


  const { toggle, clear } = props;
  const dispatch = useDispatch();

  const changePost = (prop, payload) => {
    setPostItemState(s => ({ ...s, [prop]: payload }));
  };
  const editPostForm = new FormData();

  const editPostField = field => {
    if (props.postItem[field] !== postItemState[field]) {
      editPostForm.append(field, postItemState[field]);
    }
  };

  const { loading, request: editPostAPI } = useHttp({
    requestCallback: editPost,
    onLoad: res => {
      dispatch(companyAdminEditPost(postItemState, res));
      toggle();
      addNotification('Post was edited successfully', 'success');
    },
    onError: res => {
      toggle();
      clear();
      addNotification(res.message, 'danger');
    },
  });

  const onEditPost = () => {
    editPostField('title');
    editPostField('description');
    editPostField('json');
    editPostField('obj');
    editPostField('mtl');
    editPostField('excel');
    editPostField('pdf');

    return editPostAPI({
      id: postItemState._id,
      body: editPostForm,
    });
  };

  return (
    <MDBModal
      isOpen={props.isOpen}
      toggle={choseToggle(loading, toggle)}
      centered
    >
      <MDBModalHeader toggle={choseToggle(loading, toggle)}>
        Edit post
      </MDBModalHeader>
      <MDBModalBody>
        <form>
          <MDBInput
            size="sm"
            label="Title"
            className='mdb-input'
            value={postItemState.title}
            onChange={e => changePost('title', e.target.value)}
            required
            disabled={loading}
          />
          <MDBInput
            size="sm"
            label="Description"
            className='mdb-input'
            value={postItemState.description}
            onChange={e => changePost('description', e.target.value)}
            required
            disabled={loading}
          /> 
          <MDBBox className="mb-2">
            <input
              type="file"
              className="file-input"
              id="json_input"
              onChange={e => {
                changePost('json', e.target.files[0]);
              setJson('jsonselected')}
              }
              accept={'.json'}
              required
              disabled={loading}
            />
            <label
              htmlFor="json_input"
              className={
                json === "jsonselected"
                  ? "sharePending-button active-toggle border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
                  : "sharePending-button border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
              }            >
              Choose JSON file
            </label>
          </MDBBox>
          <MDBBox className="mb-2">
            <input
              type="file"
              className="file-input"
              id="xlsx_input"
              onChange={e =>{
                changePost('excel', e.target.files[0]);
                setXlsx('xlsxselected')
              } 
            }
              accept={'.xlsx'}
              required
              disabled={loading}
            />
            <label
              htmlFor="xlsx_input"
              className={
                xlsx === "xlsxselected"
                  ? "sharePending-button active-toggle border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
                  : "sharePending-button border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
              }            >
              Choose XLSX file
            </label>
          </MDBBox>
          <MDBBox className="mb-2">
            <input
              type="file"
              className="file-input"
              id="obj_input"
              onChange={e => {
                changePost('obj', e.target.files[0]);
               setObj('objselected')
              }

              }
              accept={'.obj'}
              required
              disabled={loading}
            />
            <label
              htmlFor="obj_input"
              className={
                obj === "objselected"
                  ? "sharePending-button active-toggle border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
                  : "sharePending-button border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
              } 
            >
              Choose OBJ file
            </label>
          </MDBBox>
          <MDBBox className="mb-2">
            <input
              type="file"
              className="file-input"
              id="mtl_input"
              onChange={e => {
                changePost('mtl', e.target.files[0])
                 setMtl('mtlselected')
              }
              }
              accept={'.mtl'}
              required
              disabled={loading}
            />
            <label
              htmlFor="mtl_input"
              className={
                mtl === "mtlselected"
                  ? "sharePending-button active-toggle border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
                  : "sharePending-button border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
              }            >
              Choose MTL file
            </label>
          </MDBBox>

          <MDBBox className="mb-2">
            <input
              type="file"
              className="file-input"
              id="pdf_input"
              onChange={e => {
                changePost('pdf', e.target.files[0]);
                setPdf('pdfSelected')
              }}
              accept={'.pdf'}
              required
              disabled={loading}
            />
            <label
              htmlFor="pdf_input"
              className={
                pdf === "pdfSelected"
                  ? "sharePending-button active-toggle border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
                  : "sharePending-button border-bid radius-btn text-center py-2 w-100 file-input-btn m-0"
              }
              // className="border-bid text-white bg-bid radius-btn text-center py-2 file-input-btn w-100"
            >
              Choose PDF file
            </label>
          </MDBBox>

          <MDBBtn
            size="sm"
            color=''
            className="border-bid text-bid bg-white radius-btn text-center py-2 file-input-btn w-100 text-inherit shadow-none m-0"
            onClick={onEditPost}
            disabled={loading}
          >
            Edit
          </MDBBtn>
          {loading ? <Loading color="dark" text="Editing..." /> : null}
        </form>
      </MDBModalBody>
    </MDBModal>
  );
};


EditPostModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default EditPostModal;
